import { render, staticRenderFns } from "./ConfirmOtp.vue?vue&type=template&id=5f0cd59c&scoped=true&"
import script from "./ConfirmOtp.vue?vue&type=script&lang=js&"
export * from "./ConfirmOtp.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmOtp.vue?vue&type=style&index=0&id=5f0cd59c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0cd59c",
  null
  
)

export default component.exports